import { NotSupportedConfig } from '@/models/supported-browsers.model';
import {
    browserName, browserVersion, osName, isMobile,
} from '@/helpers/mobile-device-detect';

const _detectWebpSuppot = () => {
    const browser = browserName.toLowerCase();
    const version = Number(browserVersion.split('.')[0]);
    if (browser === 'safari' && version >= 16) return true;
    return document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') === 0;
};

export const isWebpSupported = _detectWebpSuppot();
export const getImageExtension = (hasWebpImages: boolean) => (isWebpSupported && hasWebpImages ? '.webp' : '.jpg');
export const getMapImageExtension = (hasWebpImages: boolean) => (isWebpSupported && hasWebpImages ? '.webp' : '.png');

export default function checkBrowserSupport() {
    const browser = browserName.toLowerCase();
    const version = Number(browserVersion.split('.')[0]);
    const os = osName.toLowerCase();

    const notSupportedDesktop: NotSupportedConfig = {
        chrome: { below: 55 },
        opera: { below: 42 },
        firefox: { below: 52 },
        safari: { below: 10 },
        edge: { fullySupported: true },
        yandex: { notSupported: true },
        ie: { notSupported: true },
    };

    const notSupportedMobile: NotSupportedConfig = {
        ios: { below: 10 },
        android: { below: 4 },
    };

    const rules = isMobile ? notSupportedMobile[os] : notSupportedDesktop[browser];

    if (!rules) return true;
    if (rules.notSupported) return false;
    if (rules.fullySupported) return true;
    if (Number.isNaN(version)) return true;
    if (rules.below != null && version < rules.below) return false;
    return true;
}
